
export default {
  list: null,
  max: 0,
  offset: 0,
}
